import React from 'react';
import PageShell from '../components/layout/PageShell';
import { useNavigate } from 'react-router-dom';

const items = [
  {
    id: 'bolt',
    name: 'BOLT',
    tagline: 'Okta migration accelerator tooling',
    desc: 'Pre-built tooling for large-scale Okta migrations. Best for enterprise accounts moving from legacy identity providers.',
    whenToUse: 'Large-scale Okta migrations or CIAM transformations.',
    cta: 'Start an Engagement',
    useCaseMatch: 'Migration',
  },
  {
    id: 'watt',
    name: 'WATT',
    tagline: 'Web Access Tracking Terminal',
    desc: 'Spin up a protected REST endpoint backed by your own Node.js in minutes - write the handler, set an auth rule, get a URL. No infrastructure to manage.',
    whenToUse: 'Quickly testing or standing up a temporary REST endpoint.',
    cta: 'Start an Engagement',
  },
  {
    id: 'amp',
    name: 'AMP',
    tagline: 'Application Management Portal',
    desc: 'Bulk entity management, today focused on managing Auth0 applications at scale - including reviewing application configurations against RAAH-recommended configs. Support for other Auth0 entities (connections, APIs) and other platforms beyond Auth0 is on the roadmap.',
    whenToUse: 'Bulk-managing Auth0 applications across a tenant, or auditing them against RAAH-recommended configuration.',
    cta: 'Start an Engagement',
    productMatch: 'Auth0 (B2C/B2B/B2B2C)',
  },
];

const styles = {
  grid: { display: 'flex', flexDirection: 'column', gap: '16px' },
  card: {
    border: '1px solid #e5e5e5', borderRadius: '8px', padding: '20px',
  },
  name: { fontSize: '16px', fontWeight: '700', marginBottom: '2px' },
  tagline: { fontSize: '12px', color: '#888', marginBottom: '10px' },
  desc: { fontSize: '13px', color: '#444', marginBottom: '8px' },
  whenLabel: { fontSize: '11px', fontWeight: '600', color: '#555', textTransform: 'uppercase', marginBottom: '2px' },
  when: { fontSize: '12px', color: '#666', marginBottom: '14px' },
  ctaBtn: {
    padding: '8px 18px', background: '#fd5f0d', color: '#fff',
    border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '600', cursor: 'pointer',
  },
};

function Marketplace() {
  const navigate = useNavigate();
  return (
    <PageShell title="Marketplace" desc="Explore RAAH's productized offerings and tools.">
      <div style={styles.grid}>
        {items.map(item => (
          <div key={item.id} style={styles.card}>
            <div style={styles.name}>{item.name}</div>
            <div style={styles.tagline}>{item.tagline}</div>
            <div style={styles.desc}>{item.desc}</div>
            <div style={styles.whenLabel}>When to use</div>
            <div style={styles.when}>{item.whenToUse}</div>
            <button
              style={styles.ctaBtn}
              onClick={() => navigate('/engage', {
                state: { interestLabel: item.name, product: item.productMatch, useCase: item.useCaseMatch },
              })}
            >{item.cta}</button>
          </div>
        ))}
      </div>
    </PageShell>
  );
}

export default Marketplace;
